import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { ScormPackageModel } from "src/models/scormPackageModel";
import { TrackingResumeModel } from "src/models/trackingResumeModel";
import { UtilisateurService } from "./utilisateur.service";
import { ScormPackageProgressionModel } from "src/models/scormPackageProgressionModel";
import { EProgressionPaquet } from "src/enum/eProgressionPaquet";
import { AttachedDocumentModel } from "src/models/attachedDocumentModel";
import { VideoStatusModel } from "src/models/videoStatusModel";

declare global {
  interface Window {
    scormId?: number;
    ssoId?: string;
    entiteId?: number;
    utilisateurId?: number;
    learnerName?: string;
    formationGroupeId?: number | null;
    currentLanguage?: string;
    dataSession?: any;
    initialData?: Map<string, any>;
    sessionId?: number;
    configScorm?: any;
    modulesScorm?: any;
    previewMode?: boolean;
    scormContentUrl?: string;
    getAccessToken?: () => Promise<string | null>;
    refreshAccessToken?: () => Promise<string | null>;
    rejouerEvenementsEnAttente?: () => void;
  }
}

export const SCORM_SESSION_STORAGE_KEY = 'scormSessionState';

@Injectable({
  providedIn: 'root'
})
export class ScormService {
  public scormPackages: ScormPackageModel[] = [];

  private baseUrl = environment.api_LMS;

  constructor(private http: HttpClient, private utilisateurService: UtilisateurService) {
  }

  getScormConfig(scormId: number) {
    return this.http.get(this.baseUrl + `scorm/ObtenirConfigScorm?scormpackageId=${scormId}`, { responseType: 'json' });
  }

  getAttachedDocuments(scormId: number): Observable<AttachedDocumentModel[]> {
    return this.http.get<AttachedDocumentModel[]>(this.baseUrl + `scorm/GetAttachedDocuments`, {
      params: { scormPackageId: scormId.toString() }
    });
  }

  getPackageVideosStatus(scormPackageId: number): Observable<VideoStatusModel> {
    return this.http.get<VideoStatusModel>(this.baseUrl + `scorm/PackageVideosStatus`, {
      params: { scormPackageId: scormPackageId.toString() }
    });
  }

  getScormContent(id: number) {
    return this.http.get(this.baseUrl + `scorm/content/${id}`, { responseType: 'text' });
  }

  getAllPackages(entiteId: number): Observable<ScormPackageModel[]> {
    return this.http.get<ScormPackageModel[]>(this.baseUrl + `scorm/getAllPackages`, {
      params: { entiteId: entiteId.toString(), utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId }
    });
  }

  obtenirTousLesPackagesAvecProgression(entiteId: number): Observable<ScormPackageProgressionModel[]> {
    return this.http.get<ScormPackageProgressionModel[]>(this.baseUrl + `scorm/obtenirTousLesPackagesAvecProgression`, {
      params: { entiteId: entiteId.toString(), utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId }
    });
  }

  getAllTrackings(): Observable<TrackingResumeModel[]> {
    return this.http.get<TrackingResumeModel[]>(this.baseUrl + `tracking/getAllTrackings`);
  }

  exporterListeContenusCompletes(entiteId: number, codeLangue: string): Observable<Blob> {
    return this.http.get(this.baseUrl + `scorm/exporterListeContenusCompletes`, {
      params: { entiteId: entiteId.toString(), codeLangue, utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId },
      responseType: 'blob'
    });
  }

  obtenirProgressionPackage(packageId: number): Observable<EProgressionPaquet> {
    return this.http.get<EProgressionPaquet>(this.baseUrl + `scorm/ObtenirProgressionPackage`, {
      params: { packageId: packageId.toString(), utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId, entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId.toString() }
    });
  }
}
